// src/components/sections/ProBono.js - Refactored with Button component
import React from 'react';
import { ArrowRight } from 'lucide-react';
import Button from '../ui/Button';

const ProBonoInitiative = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl font-serif">Pro Bono Initiative</h2>
          <div className="w-20 h-1 bg-secondary mx-auto my-4"></div>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Making justice accessible to all through dedicated community service
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl font-serif font-bold text-primary mb-4">Making Justice Accessible</h3>
            <p className="text-gray-700 mb-4">
              The firm believes in the power of the law to drive meaningful social change. As part of our commitment to justice and community service, we actively undertake pro bono litigation to support underprivileged individuals, marginalized communities, and critical social, legal, and environmental causes.
            </p>
            <p className="text-gray-700 mb-4">
              Our team is dedicated to representing those who lack the financial means to access quality legal assistance, ensuring that justice is not a privilege, but a fundamental right. From defending individuals facing wrongful prosecution to advocating for public interest matters, we leverage our legal expertise to make a tangible difference in society.
            </p>
            <p className="text-gray-700 mb-6">
              Over time, our pro bono efforts have contributed to landmark cases, reinforcing our deep-rooted litigation practice. We take immense pride in using our skills and resources to champion fairness, equality, and legal empowerment. At AMV Law, giving back is not just a responsibility—it is a privilege.
            </p>
            <div className="mt-8">
              {/* REFACTORED: Using Button component instead of custom anchor tag */}
              <Button 
                href="/contact" 
                variant="primary"
                size="lg"
                className="inline-flex items-center"
              >
                Seek Free Legal Guidance
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>
          </div>
          
          <div className="rounded-lg overflow-hidden shadow-xl">
            <img 
              src="/community-legal-aid.jpg" 
              alt="AMV Law attorneys providing legal assistance at a community center" 
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';
              }}
            />
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="w-12 h-12 bg-primary-50 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Legal Clinics</h3>
            <p className="text-gray-600">
              We regularly organize free legal clinics in underserved communities, providing guidance on various legal issues including housing, employment, and family matters.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="w-12 h-12 bg-primary-50 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Representation</h3>
            <p className="text-gray-600">
              Our attorneys take on impactful cases for individuals and groups who cannot afford legal representation, with a focus on civil rights, discrimination, and access to basic services.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="w-12 h-12 bg-primary-50 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Community Education</h3>
            <p className="text-gray-600">
              We conduct workshops and seminars to educate communities about their legal rights and how to navigate the legal system, empowering individuals with legal knowledge.
            </p>
          </div>
        </div>
        
        <div className="text-center mt-16">
          <p className="text-gray-600 italic mb-6">
            "Equal access to justice is not just a legal principle; it's a fundamental human right. Our pro bono work is a testament to this belief."
          </p>
          <p className="text-gray-800 font-medium">— Mehak Gupta, Managing Partner</p>
        </div>
      </div>
    </section>
  );
};

export default ProBonoInitiative;